import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Выделенные строки в гриде.
 */

const initialState: [] = [];

export const gridSelectionChangesSlice = createSlice({
  name: "gridSelectionChange",
  initialState,
  reducers: {
    gridSelectionChangesData: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { gridSelectionChangesData } = gridSelectionChangesSlice.actions;

export default gridSelectionChangesSlice.reducer;
